import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { MONTHS } from '../../config/settings/constant'
import { getAveragePay, getTotalPurchases } from '../../services/summary'

export const GET_TOTAL_PURCHASES = 'GET_TOTAL_PURCHASES'
export const GET_TOTAL_PURCHASES_ERROR = 'GET_TOTAL_PURCHASES_ERROR'
export const GET_TOTAL_PURCHASES_SUCCESS = 'GET_TOTAL_PURCHASES_SUCCESS'
export const onGetTotalPurchases = makeActionCreator(GET_TOTAL_PURCHASES)
export const onGetTotalPurchasesError = makeActionCreator(GET_TOTAL_PURCHASES_ERROR, 'payload')
export const onGetTotalPurchasesSuccess = makeActionCreator(GET_TOTAL_PURCHASES_SUCCESS, 'payload')
export const onGetTotalPurchasesThunk = payload => async dispatch => {
  dispatch(onGetTotalPurchases())

  try {
    const {
      data: { payload: data }
    } = await getTotalPurchases({ actionType: GET_TOTAL_PURCHASES, dni: payload })
    const rangeDate = {
      initialMonth: MONTHS[data.periodo.mesInicial - 1],
      initialYear: data.periodo.agnoInicial,
      finalMonth: MONTHS[data.periodo.mesFinal - 1],
      finalYear: data.periodo.agnoFinal
    }
    const totalPurchaseAmount = data.montoTotalCompras === null ? -1 : Math.round(data.montoTotalCompras)

    return dispatch(
      onGetTotalPurchasesSuccess({
        totalPurchaseAmount,
        rangeDate
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 404:
        reason = 'NOT_FOUND'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetTotalPurchasesError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const GET_AVERAGE_PAY = 'GET_AVERAGE_PAY'
export const GET_AVERAGE_PAY_ERROR = 'GET_AVERAGE_PAY_ERROR'
export const GET_AVERAGE_PAY_SUCCESS = 'GET_AVERAGE_PAY_SUCCESS'
export const onGetAveragePay = makeActionCreator(GET_AVERAGE_PAY)
export const onGetAveragePayError = makeActionCreator(GET_AVERAGE_PAY_ERROR, 'payload')
export const onGetAveragePaySuccess = makeActionCreator(GET_AVERAGE_PAY_SUCCESS, 'payload')
export const onGetAveragePayThunk = payload => async dispatch => {
  dispatch(onGetAveragePay())

  try {
    const {
      data: { payload: averagePay }
    } = await getAveragePay({ actionType: GET_AVERAGE_PAY, dni: payload })

    const period = averagePay.periodo
    const rangeDate = {
      initialMonth: MONTHS[period.mesInicial - 1],
      initialYear: period.añoInicial,
      finalMonth: MONTHS[period.mesFinal - 1],
      finalYear: period.añoFinal
    }
    const sigfe = averagePay.data.sigfe
    const days = averagePay.data.dias
    const updatedAt = averagePay.fechaActualizacion

    return dispatch(
      onGetAveragePaySuccess({
        rangeDate,
        sigfe,
        days,
        updatedAt
      })
    )
  } catch (error) {
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 404:
        reason = 'NOT_FOUND'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetAveragePayError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
